import { useMemo } from 'react';
import { Locale } from '@/types/locale';

export const useIsSelectedLanguage = (language: Locale): boolean => {
	const defaultLanguage = process.env.NEXT_PUBLIC_LANGUAGE;

	return useMemo(() => {
		return language === defaultLanguage;
	}, [language, defaultLanguage]);
};
